export const DIRECTORY_ADD_TAGS = 'directory-add-tags';
export const DIRECTORY_FETCH = 'directory-fetch';
export const DOCUMENT_ADD_TAGS = 'document-add-tags';
export const DOCUMENT_REMOVE_TAG = 'document-remove-tag';
export const DOCUMENT_ROTATE = 'document-rotate';
export const DOCUMENT_SEARCH = 'document-search';
export const DOCUMENT_SHOW = 'document-show';
export const DOCUMENTS_CLEAR = 'documents-clear';
export const SECURITY_FETCH_USER = 'security-fetch-user';
export const SECURITY_LOGOUT = 'security-logout';
export const SECURITY_REQUEST_TOKEN = 'security-request-token';
export const SECURITY_STORE_TARGET_URL = 'security-store-target-url';
export const TAGS_FETCH = 'tags-fetch';
